const INCEPTION_YEAR = 2001;

export const currentYear = () => new Date().getFullYear();

export const yearsInBusiness = () => currentYear() - INCEPTION_YEAR;

/** =======================================
 *  Header Scrolling Functionality.
 * ======================================= */

// Pages that have scrolling header functionality.
export const SCROLLING_ROUTES = ['Label Interactive', 'About', 'Careers'];

// Default listener.
export const headerScrollListener = () => {
  // Get decision variables.
  const hasScrollY = 'scrollY' in window;
  const scrollY = hasScrollY ? window.scrollY : document.documentElement.scrollTop;
  const clslst = document.body.classList;

  // Check body classes.
  const hasHalf = clslst.contains('half-vh');
  const hasScrl = clslst.contains('scroll-page');

  // Add default class.
  if (!hasScrl) {
    clslst.add('scroll-page');
  }

  // If more than halfway down the screen.
  if ((scrollY > 45) && (!hasHalf)) {
    clslst.add('half-vh');
  }

  // If less than halfway down the screen.
  if ((scrollY < 45) && (hasHalf)) {
    clslst.remove('half-vh');
  }
};

// Kicks scroll event, accepts custom listener to allow for growth.
export const startHeaderScroll = (listener) => {
  listener();
  document.addEventListener('scroll', listener);
};

// Kills scroll event, accepts custom listener.
export const stopHeaderScroll = (listener) => {
  document.body.classList.remove('scroll-page');
  document.removeEventListener('scroll', listener);
};

export const requireAll = requireContext => requireContext.keys().map(requireContext);



// WEBPACK FOOTER //
// ./src/services/utils.js